/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TransportTypesRouteImport } from './routes/transport-types'
import { Route as RolesRouteImport } from './routes/roles'
import { Route as PushRouteImport } from './routes/push'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as ModerationRouteImport } from './routes/moderation'
import { Route as LogsRouteImport } from './routes/logs'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LegalEntityTariffsRouteImport } from './routes/legal-entity-tariffs'
import { Route as LegalEntityLedgerRouteImport } from './routes/legal-entity-ledger'
import { Route as LegalEntitiesRouteImport } from './routes/legal-entities'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EmployeesRouteImport } from './routes/employees'
import { Route as CourierLedgerRouteImport } from './routes/courier-ledger'
import { Route as AppVersionsRouteImport } from './routes/app-versions'
import { Route as ActivityTypesRouteImport } from './routes/activity-types'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TariffsIndexRouteImport } from './routes/tariffs/index'
import { Route as CouriersIndexRouteImport } from './routes/couriers/index'
import { Route as TariffsTariffIdRouteImport } from './routes/tariffs/$tariffId'
import { Route as DictionariesRegionsRouteImport } from './routes/dictionaries/regions'
import { Route as CouriersUserIdRouteImport } from './routes/couriers/$userId'

const TransportTypesRoute = TransportTypesRouteImport.update({
  id: '/transport-types',
  path: '/transport-types',
  getParentRoute: () => rootRouteImport,
} as any)
const RolesRoute = RolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const PushRoute = PushRouteImport.update({
  id: '/push',
  path: '/push',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const ModerationRoute = ModerationRouteImport.update({
  id: '/moderation',
  path: '/moderation',
  getParentRoute: () => rootRouteImport,
} as any)
const LogsRoute = LogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalEntityTariffsRoute = LegalEntityTariffsRouteImport.update({
  id: '/legal-entity-tariffs',
  path: '/legal-entity-tariffs',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalEntityLedgerRoute = LegalEntityLedgerRouteImport.update({
  id: '/legal-entity-ledger',
  path: '/legal-entity-ledger',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalEntitiesRoute = LegalEntitiesRouteImport.update({
  id: '/legal-entities',
  path: '/legal-entities',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesRoute = EmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => rootRouteImport,
} as any)
const CourierLedgerRoute = CourierLedgerRouteImport.update({
  id: '/courier-ledger',
  path: '/courier-ledger',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVersionsRoute = AppVersionsRouteImport.update({
  id: '/app-versions',
  path: '/app-versions',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityTypesRoute = ActivityTypesRouteImport.update({
  id: '/activity-types',
  path: '/activity-types',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TariffsIndexRoute = TariffsIndexRouteImport.update({
  id: '/tariffs/',
  path: '/tariffs/',
  getParentRoute: () => rootRouteImport,
} as any)
const CouriersIndexRoute = CouriersIndexRouteImport.update({
  id: '/couriers/',
  path: '/couriers/',
  getParentRoute: () => rootRouteImport,
} as any)
const TariffsTariffIdRoute = TariffsTariffIdRouteImport.update({
  id: '/tariffs/$tariffId',
  path: '/tariffs/$tariffId',
  getParentRoute: () => rootRouteImport,
} as any)
const DictionariesRegionsRoute = DictionariesRegionsRouteImport.update({
  id: '/dictionaries/regions',
  path: '/dictionaries/regions',
  getParentRoute: () => rootRouteImport,
} as any)
const CouriersUserIdRoute = CouriersUserIdRouteImport.update({
  id: '/couriers/$userId',
  path: '/couriers/$userId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity-types': typeof ActivityTypesRoute
  '/app-versions': typeof AppVersionsRoute
  '/courier-ledger': typeof CourierLedgerRoute
  '/employees': typeof EmployeesRoute
  '/faq': typeof FaqRoute
  '/legal-entities': typeof LegalEntitiesRoute
  '/legal-entity-ledger': typeof LegalEntityLedgerRoute
  '/legal-entity-tariffs': typeof LegalEntityTariffsRoute
  '/login': typeof LoginRoute
  '/logs': typeof LogsRoute
  '/moderation': typeof ModerationRoute
  '/orders': typeof OrdersRoute
  '/push': typeof PushRoute
  '/roles': typeof RolesRoute
  '/transport-types': typeof TransportTypesRoute
  '/couriers/$userId': typeof CouriersUserIdRoute
  '/dictionaries/regions': typeof DictionariesRegionsRoute
  '/tariffs/$tariffId': typeof TariffsTariffIdRoute
  '/couriers': typeof CouriersIndexRoute
  '/tariffs': typeof TariffsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity-types': typeof ActivityTypesRoute
  '/app-versions': typeof AppVersionsRoute
  '/courier-ledger': typeof CourierLedgerRoute
  '/employees': typeof EmployeesRoute
  '/faq': typeof FaqRoute
  '/legal-entities': typeof LegalEntitiesRoute
  '/legal-entity-ledger': typeof LegalEntityLedgerRoute
  '/legal-entity-tariffs': typeof LegalEntityTariffsRoute
  '/login': typeof LoginRoute
  '/logs': typeof LogsRoute
  '/moderation': typeof ModerationRoute
  '/orders': typeof OrdersRoute
  '/push': typeof PushRoute
  '/roles': typeof RolesRoute
  '/transport-types': typeof TransportTypesRoute
  '/couriers/$userId': typeof CouriersUserIdRoute
  '/dictionaries/regions': typeof DictionariesRegionsRoute
  '/tariffs/$tariffId': typeof TariffsTariffIdRoute
  '/couriers': typeof CouriersIndexRoute
  '/tariffs': typeof TariffsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity-types': typeof ActivityTypesRoute
  '/app-versions': typeof AppVersionsRoute
  '/courier-ledger': typeof CourierLedgerRoute
  '/employees': typeof EmployeesRoute
  '/faq': typeof FaqRoute
  '/legal-entities': typeof LegalEntitiesRoute
  '/legal-entity-ledger': typeof LegalEntityLedgerRoute
  '/legal-entity-tariffs': typeof LegalEntityTariffsRoute
  '/login': typeof LoginRoute
  '/logs': typeof LogsRoute
  '/moderation': typeof ModerationRoute
  '/orders': typeof OrdersRoute
  '/push': typeof PushRoute
  '/roles': typeof RolesRoute
  '/transport-types': typeof TransportTypesRoute
  '/couriers/$userId': typeof CouriersUserIdRoute
  '/dictionaries/regions': typeof DictionariesRegionsRoute
  '/tariffs/$tariffId': typeof TariffsTariffIdRoute
  '/couriers/': typeof CouriersIndexRoute
  '/tariffs/': typeof TariffsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity-types'
    | '/app-versions'
    | '/courier-ledger'
    | '/employees'
    | '/faq'
    | '/legal-entities'
    | '/legal-entity-ledger'
    | '/legal-entity-tariffs'
    | '/login'
    | '/logs'
    | '/moderation'
    | '/orders'
    | '/push'
    | '/roles'
    | '/transport-types'
    | '/couriers/$userId'
    | '/dictionaries/regions'
    | '/tariffs/$tariffId'
    | '/couriers'
    | '/tariffs'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity-types'
    | '/app-versions'
    | '/courier-ledger'
    | '/employees'
    | '/faq'
    | '/legal-entities'
    | '/legal-entity-ledger'
    | '/legal-entity-tariffs'
    | '/login'
    | '/logs'
    | '/moderation'
    | '/orders'
    | '/push'
    | '/roles'
    | '/transport-types'
    | '/couriers/$userId'
    | '/dictionaries/regions'
    | '/tariffs/$tariffId'
    | '/couriers'
    | '/tariffs'
  id:
    | '__root__'
    | '/'
    | '/activity-types'
    | '/app-versions'
    | '/courier-ledger'
    | '/employees'
    | '/faq'
    | '/legal-entities'
    | '/legal-entity-ledger'
    | '/legal-entity-tariffs'
    | '/login'
    | '/logs'
    | '/moderation'
    | '/orders'
    | '/push'
    | '/roles'
    | '/transport-types'
    | '/couriers/$userId'
    | '/dictionaries/regions'
    | '/tariffs/$tariffId'
    | '/couriers/'
    | '/tariffs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityTypesRoute: typeof ActivityTypesRoute
  AppVersionsRoute: typeof AppVersionsRoute
  CourierLedgerRoute: typeof CourierLedgerRoute
  EmployeesRoute: typeof EmployeesRoute
  FaqRoute: typeof FaqRoute
  LegalEntitiesRoute: typeof LegalEntitiesRoute
  LegalEntityLedgerRoute: typeof LegalEntityLedgerRoute
  LegalEntityTariffsRoute: typeof LegalEntityTariffsRoute
  LoginRoute: typeof LoginRoute
  LogsRoute: typeof LogsRoute
  ModerationRoute: typeof ModerationRoute
  OrdersRoute: typeof OrdersRoute
  PushRoute: typeof PushRoute
  RolesRoute: typeof RolesRoute
  TransportTypesRoute: typeof TransportTypesRoute
  CouriersUserIdRoute: typeof CouriersUserIdRoute
  DictionariesRegionsRoute: typeof DictionariesRegionsRoute
  TariffsTariffIdRoute: typeof TariffsTariffIdRoute
  CouriersIndexRoute: typeof CouriersIndexRoute
  TariffsIndexRoute: typeof TariffsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/transport-types': {
      id: '/transport-types'
      path: '/transport-types'
      fullPath: '/transport-types'
      preLoaderRoute: typeof TransportTypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roles': {
      id: '/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof RolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/push': {
      id: '/push'
      path: '/push'
      fullPath: '/push'
      preLoaderRoute: typeof PushRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/moderation': {
      id: '/moderation'
      path: '/moderation'
      fullPath: '/moderation'
      preLoaderRoute: typeof ModerationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logs': {
      id: '/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof LogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal-entity-tariffs': {
      id: '/legal-entity-tariffs'
      path: '/legal-entity-tariffs'
      fullPath: '/legal-entity-tariffs'
      preLoaderRoute: typeof LegalEntityTariffsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal-entity-ledger': {
      id: '/legal-entity-ledger'
      path: '/legal-entity-ledger'
      fullPath: '/legal-entity-ledger'
      preLoaderRoute: typeof LegalEntityLedgerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal-entities': {
      id: '/legal-entities'
      path: '/legal-entities'
      fullPath: '/legal-entities'
      preLoaderRoute: typeof LegalEntitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees': {
      id: '/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof EmployeesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courier-ledger': {
      id: '/courier-ledger'
      path: '/courier-ledger'
      fullPath: '/courier-ledger'
      preLoaderRoute: typeof CourierLedgerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app-versions': {
      id: '/app-versions'
      path: '/app-versions'
      fullPath: '/app-versions'
      preLoaderRoute: typeof AppVersionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity-types': {
      id: '/activity-types'
      path: '/activity-types'
      fullPath: '/activity-types'
      preLoaderRoute: typeof ActivityTypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tariffs/': {
      id: '/tariffs/'
      path: '/tariffs'
      fullPath: '/tariffs'
      preLoaderRoute: typeof TariffsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/couriers/': {
      id: '/couriers/'
      path: '/couriers'
      fullPath: '/couriers'
      preLoaderRoute: typeof CouriersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tariffs/$tariffId': {
      id: '/tariffs/$tariffId'
      path: '/tariffs/$tariffId'
      fullPath: '/tariffs/$tariffId'
      preLoaderRoute: typeof TariffsTariffIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dictionaries/regions': {
      id: '/dictionaries/regions'
      path: '/dictionaries/regions'
      fullPath: '/dictionaries/regions'
      preLoaderRoute: typeof DictionariesRegionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/couriers/$userId': {
      id: '/couriers/$userId'
      path: '/couriers/$userId'
      fullPath: '/couriers/$userId'
      preLoaderRoute: typeof CouriersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityTypesRoute: ActivityTypesRoute,
  AppVersionsRoute: AppVersionsRoute,
  CourierLedgerRoute: CourierLedgerRoute,
  EmployeesRoute: EmployeesRoute,
  FaqRoute: FaqRoute,
  LegalEntitiesRoute: LegalEntitiesRoute,
  LegalEntityLedgerRoute: LegalEntityLedgerRoute,
  LegalEntityTariffsRoute: LegalEntityTariffsRoute,
  LoginRoute: LoginRoute,
  LogsRoute: LogsRoute,
  ModerationRoute: ModerationRoute,
  OrdersRoute: OrdersRoute,
  PushRoute: PushRoute,
  RolesRoute: RolesRoute,
  TransportTypesRoute: TransportTypesRoute,
  CouriersUserIdRoute: CouriersUserIdRoute,
  DictionariesRegionsRoute: DictionariesRegionsRoute,
  TariffsTariffIdRoute: TariffsTariffIdRoute,
  CouriersIndexRoute: CouriersIndexRoute,
  TariffsIndexRoute: TariffsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
